import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import AppWrapper from './containers/app';
import store from './redux/store';
import styles from './styles/theme-default.module.less';
import './i18n';
import loadEnv from './constants/env';
import * as Sentry from '@sentry/react';

document.body.className = styles.body;

Sentry.init({
  environment: loadEnv.ENVIRONMENT,
  dsn: loadEnv.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/lawconnect\.com\/api/,
    /^https:\/\/staging.lawconnect\.com\/api/,
    /^https:\/\/development.lawconnect\.com\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <AppWrapper />
  </Provider>
);
